import type { EmployeeAlertInvalidPreferredFullName } from '@/common/graphql';

export const DetailDescriptionEmployeeAlertInvalidPreferredFullName = ({
  reason,
}: {
  reason: Pick<EmployeeAlertInvalidPreferredFullName, 'preferredFullName' | 'detailMessage'>;
}) => (
  <>
    <div>
      Preferred full name:&nbsp;
      {reason.preferredFullName}
    </div>
    <div>
      Reason:&nbsp;
      {reason.detailMessage}
    </div>
  </>
);
